/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on;
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="about">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Volver</span>
          </a>
        </div>
        <div class="title">CHECK LIST</div>
      </div>
    </div>
    <div class="toolbar tabbar tabbar-labels toolbar-bottom">
      <div class="toolbar-inner">
        <a href="#tab-1" class="tab-link">
          <i class="icon f7-icons if-not-md" style="color: darkslateblue;">floppy_disk</i>
          <i class="icon material-icons md-only">floppy_disk</i>
          <span class="tabbar-label">Guardar</span>
        </a>
        <a href="#tab-2" class="tab-link">
          <i class="icon f7-icons if-not-md">checkmark_alt_circle_fill</i>
          <i class="icon material-icons md-only">checkmark_alt_circle_fill</i>
          <span class="tabbar-label">Check List</span>
        </a>
        <a href="#tab-3" class="tab-link">
          <i class="icon f7-icons if-not-md">cloud_upload_fill</i>
          <i class="icon material-icons md-only">file_upload</i>
          <span class="tabbar-label">Imagenes</span>
        </a>
      </div>
    </div>
    <div class="page-content">
      <div class="block">
        <p class="row text-align-right">
          <a class="" href="#"></a>
          <a class="" href="#"></a>
          <a class="button button-fill button-small color-pink back" href="#">Cancelar</a>
        </p>
        
        <div class="list">
          <ul>
            <li class="accordion-item"><a class="item-content item-link" href="#">
                <div class="item-inner">
                  <div class="item-title">Exterior del vehiculo</div>
                </div>
              </a>
              <div class="accordion-item-content">
                <!-- Listado de checklist -->
                <div class="list media-list">
                  <ul>
                    <li>
                    <label class="item-checkbox item-content">
                      <input type="checkbox" name="demo-media-checkbox" value="1" />
                      <i class="icon icon-checkbox"></i>
                      <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">Facebook</div>
                        <div class="item-after">17:14</div>
                      </div>
                      <div class="item-subtitle">New messages from John Doe</div>
                      <div class="item-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sagittis
                        tellus ut turpis condimentum, ut dignissim lacus tincidunt. Cras dolor metus, ultrices condimentum sodales sit amet, pharetra sodales eros. Phasellus vel felis tellus. Mauris rutrum ligula nec dapibus feugiat. In vel dui laoreet, commodo augue id, pulvinar lacus.</div>
                      </div>
                    </label>
                    </li>
                    <li>
                    <label class="item-checkbox item-content">
                      <input type="checkbox" name="demo-media-checkbox" value="2" />
                      <i class="icon icon-checkbox"></i>
                      <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">John Doe (via Twitter)</div>
                        <div class="item-after">17:11</div>
                      </div>
                      <div class="item-subtitle">John Doe (@_johndoe) mentioned you on Twitter!</div>
                      <div class="item-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sagittis
                        tellus ut turpis condimentum, ut dignissim lacus tincidunt. Cras dolor metus, ultrices condimentum sodales sit amet, pharetra sodales eros. Phasellus vel felis tellus. Mauris rutrum ligula nec dapibus feugiat. In vel dui laoreet, commodo augue id, pulvinar lacus.</div>
                      </div>
                    </label>
                    </li>
                    <li>
                    <label class="item-checkbox item-content">
                      <input type="checkbox" name="demo-media-checkbox" value="3" />
                      <i class="icon icon-checkbox"></i>
                      <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">Facebook</div>
                        <div class="item-after">16:48</div>
                      </div>
                      <div class="item-subtitle">New messages from John Doe</div>
                      <div class="item-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sagittis
                        tellus ut turpis condimentum, ut dignissim lacus tincidunt. Cras dolor metus, ultrices condimentum sodales sit amet, pharetra sodales eros. Phasellus vel felis tellus. Mauris rutrum ligula nec dapibus feugiat. In vel dui laoreet, commodo augue id, pulvinar lacus.</div>
                      </div>
                    </label>
                    </li>
                    <li>
                    <label class="item-checkbox item-content">
                      <input type="checkbox" name="demo-media-checkbox" value="4" />
                      <i class="icon icon-checkbox"></i>
                      <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">John Doe (via Twitter)</div>
                        <div class="item-after">15:32</div>
                      </div>
                      <div class="item-subtitle">John Doe (@_johndoe) mentioned you on Twitter!</div>
                      <div class="item-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sagittis
                        tellus ut turpis condimentum, ut dignissim lacus tincidunt. Cras dolor metus, ultrices condimentum sodales sit amet, pharetra sodales eros. Phasellus vel felis tellus. Mauris rutrum ligula nec dapibus feugiat. In vel dui laoreet, commodo augue id, pulvinar lacus.</div>
                      </div>
                    </label>
                    </li>
                  </ul>
                </div>
                
                <!-- Listado de checklist -->
              </div>
            </li>
            <li class="accordion-item"><a class="item-content item-link" href="#">
                <div class="item-inner">
                  <div class="item-title">Interior del vehiculo</div>
                </div>
              </a>
              <div class="accordion-item-content">
                <div class="block">
                  <p>Item 2 content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla dignissim viverra
                    velit sed euismod. Mauris sed quam vehicula, dapibus ante a, aliquet augue.</p>
                </div>
              </div>
            </li>
            <li class="accordion-item"><a class="item-content item-link" href="#">
                <div class="item-inner">
                  <div class="item-title">Operaciones adicionales</div>
                </div>
              </a>
              <div class="accordion-item-content">
                <div class="block">
                  <p>Item 3 content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla dignissim viverra
                    velit sed euismod. Mauris sed quam vehicula, dapibus ante a, aliquet augue.</p>
                </div>
              </div>
            </li>
            <li class="accordion-item"><a class="item-content item-link" href="#">
                <div class="item-inner">
                  <div class="item-title">Chapa y Pintura</div>
                </div>
              </a>
              <div class="accordion-item-content">
                <div class="block">
                  <p>Item 4 content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla dignissim viverra
                    velit sed euismod. Mauris sed quam vehicula, dapibus ante a, aliquet augue.</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  `
    }
    ;
}

framework7Component.id = '4bd8280fd5';
export default framework7Component;